export default __webpack_public_path__ + "app/images/btn-toolbar-download-normal.svg";